<template>
  <div class="container">
    <h1 class="mt-5">{{ msg }}</h1>

    <!-- First row of tiles starts -->
    <div class="row no-gutters mb5">

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--teal tile__main">
            <span class="tile__title">Actions</span>
              <i class="icon--big"><img src="./../assets/iconaid.png" class="img-fluid"/></i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--teal tile__secondary">
            <span class="tile__title">Lorem ipsum</span>
              <i class="material-icons icon--circle">add</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--teal tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
              <i class="material-icons icon--circle">input</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--teal tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
              <i class="material-icons icon--circle">question_answer</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--teal tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
              <i class="material-icons icon--circle">question_answer</i>
          </a>
        </div>
      </div>

    </div>
    <!-- First row of tiles ends -->

    <!-- Second row of tiles starts -->
    <div class="row no-gutters mb5">

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--pink tile__main">
            <span class="tile__title">Menu</span>
            <i class="icon--big"><img src="./../assets/folder.png" class="img-fluid"/></i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--pink tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
            <i class="material-icons icon--circle">question_answer</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>

    </div>
    <!-- Second row of tiles ends -->

    <!-- Third row of tiles start-->
    <div class="row no-gutters mb5">

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--blue tile__main">
            <span class="tile__title">Menu</span>
            <i class="icon--big"><img src="./../assets/hands.png" class="img-fluid"/></i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--blue tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
            <i class="material-icons icon--circle">attach_file</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>

    </div>
    <!-- Third row of tiles ends-->

    <!-- Fourth row of tiles starts-->
    <div class="row no-gutters">
      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--green tile__main">
            <span class="tile__title">Menu</span>
            <i class="icon--big"><img src="./../assets/calendar.png" class="img-fluid"/></i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20">
        <div class="card card__tile">
          <a href="#" class="tile tile--blue tile__secondary">
            <span class="tile__title">Lorem ipsum dolor sit amet</span>
            <i class="material-icons icon--circle">check</i>
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>
      <div class="col-12 col-sm-4 col-lg-3 w-20"></div>

    </div>
    <!-- Fourth row of tiles ends -->
  </div>
</template>

<script>
    export default {
      name: 'ActionTiles',
      data () {
        return {
          msg: 'Aktions-Kacheln'
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "./../assets/scss/_base.scss";

  .mb5 {
    margin-bottom: 5px;
  }

  .tile {
    min-height: 180px;
    background: white;
    /*margin-bottom: 1rem;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2.4rem 0;
    height: 100%;
  }

  .tile--offset {
    /*margin-right: 5px;*/
  }

  .tile__title {
    /*padding: 5px 15px;*/
  }

  .tile--teal {
    border-top: 3px solid $teal;
    background-color: $teal;
    margin-bottom: 0;
    color: $teal;
    &:hover, &:focus {
        color: $teal;
    }
  }

  .tile--pink {
    border-top: 3px solid $pink;
    background-color: $pink;
    color: $pink;
    &:hover, &:focus {
      color: $pink;
    }
  }

  .tile--blue {
    border-top: 3px solid $blue;
    background-color: $blue;
    color: $blue;
    &:hover, &:focus {
       color: $blue;
    }
  }

  .tile--green {
    border-top: 3px solid $green;
    background-color: $green;
    color: $green;
    &:hover, &:focus {
       color: $green;
    }
  }

  .tile__main {
    color: white;
    &:hover, &:focus {
        color: white;
    }
  }

  .tile__secondary {
    background: white;
  }

  .card {
    &.card__tile {
      min-height: 180px;
      height: 100%;
      .tile__title {
        font-size: 1.2rem;
        line-height: 1.3;
        padding: 4px;
      }
      @media #{$netbook_break}{
        min-height: auto;
      }
    }
  }

  .icon--big {
    img {
      width: 4rem;
    }
  }

  @media (min-width: 992px) {
    .w-20 {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ActionTiles.vue